module.exports = __webpack_public_path__ + "static/media/toilet-white.f4051115.png";